import {
  Box,
  ColumnLayout,
  Container,
  Header,
} from "@amzn/awsui-components-react";
import HealthStatusIndicator from "../../common/HealthStatusIndicator";
import { RedriveStatus } from "../../../types";
import { RedriveKind } from "../redriveKinds";

export interface RedriveExecutionDetailsData {
  executor?: string;
  status?: string;
  requestDate?: Date;
  count?: number;
}

interface Props {
  kind: RedriveKind;
  metadata: RedriveExecutionDetailsData | null;
  loading: boolean;
}

function ValueWithLabel({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div>
      <Box variant="awsui-key-label">{label}</Box>
      <div>{children}</div>
    </div>
  );
}

const fallback = (loading: boolean, empty = "unknown") =>
  loading ? "Loading…" : empty;

export function RedriveExecutionDetails({ kind, metadata, loading }: Props) {
  return (
    <Container header={<Header variant="h2">Redrive Execution</Header>}>
      <ColumnLayout columns={4} variant="text-grid">
        <ValueWithLabel label="Executor">
          {metadata?.executor || fallback(loading)}
        </ValueWithLabel>
        <ValueWithLabel label="Status">
          {metadata?.status ? (
            <HealthStatusIndicator
              healthStatus={metadata.status as RedriveStatus}
            />
          ) : (
            fallback(loading)
          )}
        </ValueWithLabel>
        <ValueWithLabel label="Request Date">
          {metadata?.requestDate
            ? metadata.requestDate.toLocaleString()
            : fallback(loading, "-")}
        </ValueWithLabel>
        <ValueWithLabel label={`${kind.name}s Redriven`}>
          {metadata?.count != null && metadata.count >= 0
            ? metadata.count.toLocaleString()
            : fallback(loading)}
        </ValueWithLabel>
      </ColumnLayout>
    </Container>
  );
}
